import { EditingLeaseState, type EditingLeaseRead } from '../schemas'

export function isHeldByAnotherUser(
  lease: EditingLeaseRead | null | undefined
): lease is EditingLeaseRead & { state: EditingLeaseState.HELD; is_current_user_holder: false } {
  return lease?.state === EditingLeaseState.HELD && !lease.is_current_user_holder
}
